module.exports = __webpack_public_path__ + "img/13.09132720.jpg";